module.exports = __webpack_public_path__ + "img/placeholder.2e0c2db7.png";